import { useState } from "react";
import { faqs } from "@/mocks/baogua";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="w-full bg-gradient-to-b from-background-100 to-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-question-line"></i> 关于吃瓜，你想问的
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
            爆瓜台<span className="font-display text-primary-500">常见问题</span>
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => (
            <div key={f.q} className="overflow-hidden rounded-2xl bg-background-50 transition hover:bg-background-50/80">
              <button onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5">
                <span className="flex items-center gap-3 text-base font-semibold text-foreground-950">
                  <span className="font-display text-lg text-accent-500">Q{i + 1}</span>
                  <span>{f.q}</span>
                </span>
                <i className={`shrink-0 text-xl text-primary-600 transition-transform ${open === i ? "rotate-45" : ""}`}>
                  {open === i ? "ri-subtract-line" : "ri-add-line"}
                </i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <div className="flex gap-3 border-t border-background-200/70 pt-4">
                    <span className="font-display text-lg text-secondary-600">A</span>
                    <p className="text-sm leading-relaxed text-foreground-700 md:text-[15px]">{f.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-center">
          <button onClick={() => document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" })}
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition">
            <i className="ri-chat-smile-line"></i> 还有其他问题？来找我们唠唠
          </button>
        </div>
      </div>
    </section>
  );
}